export const getIsViewOnlyUser = (managementOrganizationMemberships: any[]) => {
  return managementOrganizationMemberships.length > 0
}
